﻿import { Client, GraphRequestOptions, PageCollection, PageIterator, ResponseType } from "@microsoft/microsoft-graph-client";
import { AuthCodeMSALBrowserAuthenticationProvider } from "@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser";
import { endOfWeek, startOfWeek } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import { User, Event } from "microsoft-graph";

let graphClient: Client | undefined = undefined;

function ensureClient(authProvider: AuthCodeMSALBrowserAuthenticationProvider) {
    if (!graphClient) {
        graphClient = Client.initWithMiddleware({
            authProvider: authProvider
        });
    }

    return graphClient;
}

export async function getUser(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<User> {
    ensureClient(authProvider);

    // Return the /me API endpoint result as a User object
    const user: User = (await graphClient!.api("/me")
        // Only retrieve the specific fields needed
        //.select('displayName,mail,mailboxSettings,userPrincipalName')
        .get()) as User;

    return user;
}

export async function getPhoto(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<string|undefined> {
    ensureClient(authProvider);
    const response = await graphClient!.api("/me/photo/$value").responseType(ResponseType.RAW).get();
    if (!response.ok) {
        return undefined;
    }
    const url = window.URL || window.webkitURL;
    const blob = await response.blob();
    const imageUrl = url.createObjectURL(blob);
    return imageUrl;
}